import {Injectable} from '../di';
import {AppInitializeService} from '../app-initialize-service';
import './progress-bar.scss';

@Injectable()
export class ProgressBarService implements AppInitializeService {
  private totalModules: number = 0;
  private loadedModules: number = 0;
  private totalImages: number = 0;
  private loadedImages: number = 0;

  private maxPercent: number = 0;

  private readonly lpContainerEl = document.getElementById('lp_container')!;
  private readonly lpBarEl = document.getElementById('lp_bar')!;
  private readonly lpBarInnerEl = document.getElementById('lp_bar_inner')!;

  constructor() {
    window.LPBar = this;
  }

  public init(): Promise<boolean> {
    this.show();
    return Promise.resolve(true);
  }

  public show() {
    this.lpContainerEl.style.visibility = 'visible';
    this.lpBarEl.style.width = '100%'; // animated
  }

  public hide() {
    document.body.removeChild(this.lpContainerEl);
    $(this.lpContainerEl).remove();
  }

  public moduleLoadingStart(weight: number = 1) {
    this.totalModules += weight || 1;
    this.recalcProgressBarWidth();
  }

  public moduleLoadingEnd(weight: number = 1) {
    this.loadedModules += weight || 1;
    this.recalcProgressBarWidth();
  }

  public imageLoadingStart(weight: number = 1) {
    this.totalImages += weight || 1;
    this.recalcProgressBarWidth();
  }

  public imageLoadingEnd(weight: number = 1) {
    this.loadedImages += weight || 1;
    this.recalcProgressBarWidth();
  }

  private recalcProgressBarWidth() {
    // In the current progress bar, we track two main processes: module loading and image preloading (if enabled).
    // The problem is that we don't know how many images we'll load (or whether we'll load them at all) until
    // all the modules are loaded. Moreover, images may not load at all. Therefore, we can't calculate
    // the capacity of a progress bar before loading.
    //
    // In the legacy code, a clever trick was used: when modules are loaded, the progress bar container (`#lp_bar`)
    // grows. And when images are loaded, the progress bar itself grows within the container. This looked a bit awkward.
    //
    // The current logic is as follows: 50% of the progress bar is used for module loading. And another 50% is used
    // for image loading, if any. If images aren't loaded at all, then we jump from 50% to 100%.

    const percentModules: number = this.totalModules === 0 ? 0 : (this.loadedModules / this.totalModules) * 50;
    const percentImages: number = this.totalImages === 0 ? 0 : (this.loadedImages / this.totalImages) * 50;
    let percent = percentModules + percentImages;
    if (percent > 100) {
      percent = 100;
    }

    if (percent > this.maxPercent) {
      this.maxPercent = percent;
      this.lpBarInnerEl.style.width = `${percent.toFixed(2)}%`;
    }
  }

  public preload_progress(currentLoaded: number, total: number) {
    // TODO use imageLoadingStart instead

    if (currentLoaded > this.loadedImages) {
      this.loadedImages = currentLoaded;
    }

    if (total > this.totalImages) {
      this.totalImages = total;
    }

    this.recalcProgressBarWidth();
  }

  public preload_end() {
    this.lpBarInnerEl.style.width = `100%`;
  }
}

declare global {
  interface Window {
    /**
     * @deprecated
     */
    LPBar: ProgressBarService;
  }

  /**
   * @deprecated
   */
  const LPBar: ProgressBarService;
}
